import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class SetDirector extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const { depJsChargeUserId, jsChargeEmployeeCode, jsChargeUserCompellation, hospitalDepartmentId } = record;
        this.setState({
            params: {
                hospitalDepartmentId,
                userId: depJsChargeUserId,
                userName: jsChargeUserCompellation ? `${jsChargeUserCompellation}[${jsChargeEmployeeCode}]` : undefined,
            },
        }, () => {
            this.setState({ visible: true });
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params } = this.state;
        const { userId, hospitalDepartmentId } = params;
        if (!userId) {
            message.warning('请选择科室leader');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.setDepJsChargeUserByHospitalEnterprise,
            data: {
                hospitalDepartmentId,
                jsChargeUserId: userId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (option) => {
        const { params } = this.state;
        const { value, text } = option || {};
        params.userId = value;
        params.userName = text;
        this.setState({ params });
    }

    render() {
        const { visible, loading, params } = this.state;
        const { userName } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title='配置科室leader'
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="420px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">{asterisk}科室leader:</div>
                                <div className="item-right">
                                    <SearchRetrieve
                                        keyword='userNameCode'
                                        style={{ width: 162 }}
                                        placeholder="输入姓名/工号检索"
                                        value={userName}
                                        params={{ limit: 20 }}
                                        url={API_URL.hospital.queryMemberForAddDepartmentDirectorUser}
                                        config={{ id: 'userId', name: 'name', code: 'employeeCode', show: 'user' }}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default SetDirector;


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/SetDirector.js